import React, { useCallback, FC, FormEvent } from "react";
import { FormikConfig, FormikProvider, useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { selectCurrentUserState } from "src/redux/currentUser/selector";
import { selectorMessage } from "src/redux/message/selector";
import { sendMessageAsync } from "src/redux/message/actions";
import { Button } from "src/components/Button";
import { FileField } from "src/components/FormField/FileField";
import { TextField } from "src/components/FormField/TextField";
import { MEDIA_ACCEPT } from "src/components/FormField/constants";
import { FormFieldVariants } from "src/components/FormField/types";
import { ReactComponent as AttachIcon } from "src/assets/icons/attach.svg";
import { ReactComponent as SendIcon } from "src/assets/icons/send.svg";
import { IMessage } from "src/@types/message";
import { MESSAGE_VALIDATION_SCHEMA } from "./constants";
import { chatWindowTrns } from "./trns";
import { IMessageFormik } from "./types";

const INITIAL_VALUES = {
  message: "",
  file: undefined,
};

interface Props {
  chatId: number;
  addMessage: (newMessage: IMessage) => void;
}

export const AddMessage: FC<Props> = ({ chatId, addMessage }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const { currentUser } = useAppSelector(selectCurrentUserState);
  const { isLoading } = useAppSelector(selectorMessage);

  const formikProps: FormikConfig<Required<IMessageFormik>> = {
    validationSchema: MESSAGE_VALIDATION_SCHEMA,
    initialValues: INITIAL_VALUES,
    onSubmit: (values, { resetForm }) => {
      const { message, file } = values;
      const currentDate = new Date();

      // CHANGE
      const onSuccess = () => {
        addMessage({
          id: +currentDate,
          chat: chatId,
          user: currentUser.host,
          is_host: true,
          message: message.trim(),
          file: file,
          sent_at: currentDate,
        });
      };

      dispatch(
        sendMessageAsync({
          chat: chatId,
          message: message.trim(),
          file,
          onSuccess,
        })
      );

      resetForm();
    },
  };

  const formik = useFormik<IMessageFormik>(formikProps);

  const { values, submitForm } = formik;

  const onSubmitForm = useCallback(
    (e: FormEvent) => {
      e.preventDefault();
      submitForm();
    },
    [submitForm]
  );

  return (
    <FormikProvider value={formik}>
      <form
        className="flex items-center gap-5 px-3 py-2 md:px-5 bg-white-base/50 border border-purple-base rounded-20"
        autoComplete="off"
      >
        {/* <Button type="button">
          <label className="relative cursor-pointer">
            {Boolean(values.file) && (
              <span className="absolute -top-1 -right-1 w-1.5 aspect-square bg-purple-base rounded-full" />
            )}

            <AttachIcon />
            <FileField
              name="file"
              fieldClassName="hidden"
              accept={FILE_ACCEPT}
            />
          </label>
        </Button> */}

        <TextField
          fieldClassName="!p-0 text-normal"
          className="!p-0 rounded-none !bg-transparent border-none placeholder-purple-base/50 font-medium"
          errorClassName="hidden"
          variant={FormFieldVariants.PRIMARY}
          name="message"
          placeholder={t(chatWindowTrns.messagePlaceholder)}
        />

        <Button onClick={onSubmitForm} isDisabled={isLoading}>
          <SendIcon />
        </Button>
      </form>
    </FormikProvider>
  );
};
